// extracted by mini-css-extract-plugin
module.exports = {"block":"profileBonusTerm_block__2E7WF","block__title":"profileBonusTerm_block__title__nyrxk","date":"profileBonusTerm_date__15Ydo","modal":"profileBonusTerm_modal__cztup"};